import React, { useState, useEffect } from "react";
import { Stepper, Step, StepLabel, Container, Input, useEventCallback } from '@mui/material';
import './CurrencyButtonStyle.css';
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import { useLocation } from 'react-router-dom';
import { Radio, RadioGroup, FormLabel } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

import WorkshopNavbar from "../../frontend/WorkShop/WorkshopNavbar/WorkshopNavbar";
import ConferenceNavbar from "../../frontend/Conference/ConferenceNavbar";
//import WorkshopFooter from "./WorkhopFooter/WorkshopFooter";
import NewVersionAbstractFooter from "../AbstractAuth/NewVersion/NewVersionAnstractFooter";

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useDeadline } from "../../contexts/DeadlineContext";

//const steps = ['Step 1', 'Step 2', 'Step 3']; // Define your steps
const steps = ['Step 1',]; // Define your steps



function createData(
    id,
    coupon_code,
    workshop_id,
    disount,



) {
    return { id, coupon_code, workshop_id, disount, };
}



const rowssss = [
    createData(1, '123', 6),
    createData(1, 'kfsRY7IRI'),
    createData(2, 'micSSQ4CA'),
    createData(3, '789', 5),
    createData(4, '963', 7),
    createData(5, '258', 25),
    createData(6, '147', 26),



].sort((a, b) => (a.SubmitStatus < b.SubmitStatus ? -1 : 1));

const coupons = [
    { id: 1, code: '123', workshop_id: 6 },
    { id: 2, code: 'kfsRY7IRcI', workshop_id: 6 },
    { id: 3, code: 'micSSQ4CA', workshop_id: 28 },
    { id: 4, code: 'fixFDMJIK', workshop_id: 5 },
    { id: 5, code: '963', workshop_id: 7 },
    { id: 6, code: '258', workshop_id: 25 },
    { id: 7, code: '147', workshop_id: 26 },
];
const countries = [
    'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria',
    'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
    'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia',
    'Cameroon', 'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica',
    'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt',
    'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon',
    'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana',
    'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel',
    'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos',
    'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi',
    'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova',
    'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands',
    'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau',
    'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia',
    'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia',
    'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan',
    'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania',
    'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda',
    'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam',
    'Yemen', 'Zambia', 'Zimbabwe'
];

const rows = [
    createData(1, '123', 6),
    createData(1, 'kfsRY7IRI'),
    createData(2, 'micSSQ4CA'),
    createData(3, 'fixFDMJIK', 5),
    createData(4, '963', 7),
    createData(5, '258', 25),
    createData(6, '147', 26),
].map((row, index) => {
    const coupon = coupons.find((coupon) => coupon.code === row.couponCode);
    const discount = coupon ? coupon.discount : 0;
    return { ...row, discount };
}).sort((a, b) => (a.SubmitStatus < b.SubmitStatus ? -1 : 1));

const ConferencePartiticpantForm = () => {
    const { offButton, abstractHomeSetup, getAbstractDeadLineStatus, triggerRefresh } = useDeadline();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const cardStyles = {
        width: isSmallScreen ? '85vw' : isMediumScreen ? '80vw' : '60vw',
        margin: 'auto',
    };
    const gradientBackground = '#05597D';
    const location = useLocation();
    const URL = window.location.href;
    const id = document.URL.split("/").slice(-1)[0];



    const [activeStep, setActiveStep] = useState(0);
    const [formData, setFormData] = useState({
        // Initialize form data here
        firstName: '',
        lastName: '',
        email: '',
    });
    const history = useHistory();
    const [disabled, setdisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isChecked, setChecked] = useState(false);
    const eventName = localStorage.getItem('eventname');

    const eventid = localStorage.getItem('eventid');


    const event_affiliate_status = localStorage.getItem('event_affiliation_source');
    const defaultCurrency = abstractHomeSetup?.default_currency || 'USD';

    // Always use USD if event_affiliate_status exists, otherwise use defaultCurrency
    const [selectedCurrency, setSelectedCurrency] = useState(
        event_affiliate_status ? 'USD' : defaultCurrency
    );

    useEffect(() => {
        // Only update if event_affiliate_status doesn't exist
        if (defaultCurrency && !event_affiliate_status) {
            setSelectedCurrency(defaultCurrency);
        }
    }, [defaultCurrency, event_affiliate_status]);

    const currencyOptions = [
        ...(abstractHomeSetup?.saudi_riyal === 1 ? [{ value: 'SAR', label: 'Saudi Riyal' }] : []),
        ...(abstractHomeSetup?.uae_darham === 1 ? [{ value: 'ARE', label: 'UAE Dirham' }] : []),
        ...(abstractHomeSetup?.usa_dollor === 1 ? [{ value: 'USD', label: 'US Dollar' }] : []),
    ];

    // const event_affiliate_status = localStorage.getItem('event_affiliation_source');
    // //const [selectedCurrency, setSelectedCurrency] = useState(event_affiliate_status ? 'USA' :'SAR'); // Default to Saudi Riyal
    // //const [selectedCurrency, setSelectedCurrency] = useState(event_affiliate_status ? 'USA' : 'USA'); // You can update this logic if needed
    // const defaultCurrency = abstractHomeSetup?.default_currency || 'USD';


    // const [selectedCurrency, setSelectedCurrency] = useState(event_affiliate_status ? 'USA' : defaultCurrency); // You can update this logic if needed
    //  useEffect(() => {
    //     if (defaultCurrency) {
    //         setSelectedCurrency(defaultCurrency);
    //     }
    // }, [defaultCurrency]);
    // const currencyOptions = [
    //     ...(abstractHomeSetup?.saudi_riyal === 1 ? [{ value: 'SAR', label: 'Saudi Riyal' }] : []),
    //     ...(abstractHomeSetup?.uae_darham === 1 ? [{ value: 'ARE', label: 'UAE Dirham' }] : []),
    //     ...(abstractHomeSetup?.usa_dollor === 1 ? [{ value: 'USA', label: 'US Dollar' }] : []),
    // ];


    const [nameTitle, setNameTitle] = useState('');
    const [gender, setGender] = useState('0'); // state to hold the selected value
    const [country, setCountry] = useState('Saudi Arabia');
    const [registrationType, setRegistrationType] = useState('');
    const [assignModule, setassignModules] = useState([]);
    const [checkmodules, setCheckedmodules] = useState([]);
    const [conferenceCategoryData, setConferenceCategoryData] = useState([]);
    const [singleConferenceCategory, setSingleConferenceCategory] = useState('');
    const [selectedConferences, setSelectedConferences] = useState([]);
    const [selectedConferenceAmounts, setSelectedConferenceAmounts] = useState([]);
    const [discountMessages, setDiscountMessages] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [disabledInputs, setDisabledInputs] = useState({});
    const [showCouponInputs, setShowCouponInputs] = useState({});
    const [conferenceUsedCoupeon, setConferenceUsedCoupeon] = useState([]);
    const conference_particpant_email = localStorage.getItem('conference_particpant_email');
    const [currentDateTime, setCurrentDateTime] = useState(new Date().toISOString());
    const [conferenceTotalSeatCount, setConferenceTotalSeatCount] = useState();

    const [AsActiveSaudiCouncilNo, setAsActiveSaudiCouncilNoValue] = useState(1); // default to 1

    const [addConferenceParticpant, setAddConferenceParticpant] = React.useState({
        conference_partecpant_name: "",
        instituteWorkPlace: "",
        city: "",
        phone: "",
        participant_email: "",
        saudiCouncilno: "",
        price: "",
        profession: "",
        hostpital_organization: "",
        level_of_education: "",
        error_list: [],
    });

    const [agree, setAgree] = useState(false);


    useEffect(() => {
        if (abstractHomeSetup?.c_saudi_council_status != null) {
            setAsActiveSaudiCouncilNoValue(abstractHomeSetup.c_saudi_council_status);
        }
    }, [abstractHomeSetup])
    useEffect(() => {
        if (AsActiveSaudiCouncilNo === 0 && addConferenceParticpant.saudiCouncilno === "") {
            setAddConferenceParticpant(prev => ({
                ...prev,
                saudiCouncilno: "0000",
            }));
        }
    }, [AsActiveSaudiCouncilNo, addConferenceParticpant.saudiCouncilno]);

    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);

    React.useEffect(() => {
        // Check if at least one workshop is selected
        const hasCheckedWorkshops = Object.values(selectedConferences).some(isChecked => isChecked);
        setIsSaveButtonDisabled(!hasCheckedWorkshops);
    }, [selectedConferences]);

    useEffect(() => {
        axios.get(`api/conference-category-front-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const ccategoryData = res.data.conferenceCategories;
                const currentDateTime = res.data.currentDateTime;

                setConferenceCategoryData(ccategoryData);
                setCurrentDateTime(currentDateTime);

            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);
    useEffect(() => {
        axios.get(`api/conference-participant-used-coupeons?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const usedCoupen = res.data.usedCoupons;
                setConferenceUsedCoupeon(usedCoupen);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);



    const handleregistration = (e) => {
        const selectedRegistrationType = e.target.value;

        //Trigger API request with the selectedRegistrationType
        axios.get(`api/conference-category-front-single/${selectedRegistrationType}`)
            .then((res) => {
                if (res.status === 200) {
                    const singleConferenceData = res.data.swsd;
                    setSingleConferenceCategory(singleConferenceData);
                    setConferenceTotalSeatCount(res.data.totalSeatCount);
                    setSelectedConferenceAmounts([]); // Reset selectedConferenceAmounts when a new registration type is selected


                }
                // } else {
                //   swal('Error', 'Check API Something Wrong', 'error');
                // }
            })
            .catch((error) => {
                console.error('API Error:', error);
                swal('Error', 'An error occurred while fetching data from the API', 'error');
            });

        // Update the state with the selected registration type
        setRegistrationType(selectedRegistrationType);
    };

    const [inputValues, setInputValues] = useState({}); // Use an object to store coupon codes for each workshop
    const [usedCouponMessage, setUsedCouponMessage] = useState([]);
    //const couponCode = '123'; // Assuming coupon code is a string
    const [couponCodes, setCouponCodes] = useState({});

    const handleCouponCodeChange = (conferenceId, newValue) => {
        // Update the input value for the specific conference

        // setInputValues((prevValues) => ({
        //     ...prevValues,
        //     [conferenceId]: newValue,
        // }));

        // Trim spaces from both sides and update the state
        const trimmedValue = newValue.trim(); // Trim spaces from both sides
        setInputValues((prevValues) => ({
            ...prevValues,
            [conferenceId]: trimmedValue,
        }));

        // Check if the entered coupon matches any valid coupon
        const matchingCoupon = couponCodes.find(
            (coupon) => coupon.coupon_code === newValue && coupon.conference_id === conferenceId
        );

        if (!newValue) {
            // If coupon is cleared, reset messages
            setDiscountMessages((prevMessages) => ({
                ...prevMessages,
                [conferenceId]: '', // Clear success message
            }));
            setUsedCouponMessage((prevMessages) => ({
                ...prevMessages,
                [conferenceId]: '', // Clear error message
            }));
        } else if (!matchingCoupon) {
            // If coupon is incorrect, set an error message
            setUsedCouponMessage((prevMessages) => ({
                ...prevMessages,
                [conferenceId]: 'The Coupon is not correct',
            }));
            setDiscountMessages((prevMessages) => ({
                ...prevMessages,
                [conferenceId]: '', // Clear success message
            }));
        } else {
            // If coupon is valid, clear error messages
            setUsedCouponMessage((prevMessages) => ({
                ...prevMessages,
                [conferenceId]: '',
            }));
        }
    };

    useEffect(() => {
        axios.get(`api/conference-manage-coupon-index-front?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wksp = res.data.conferenceCouponFront;
                setCouponCodes(wksp);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);


    const [colorMap, setColorMap] = useState({});

    const handleCheckboxChange = (event, conference, conference_amount,) => {


        //const { id, workshop_url conference_day, workshop_date, workshop_start_time, workshop_end_time, workshop_code, workshop_name, workshop_coupon } = workshop;
        const { id, conference_day, confernce_date, conference_start_time, conference_name, conference_coupon } = conference;
        // Get the correct price based on current currency and affiliate status
        const price = event_affiliate_status
            ? conference.conference_discount_amount
            : getPriceByCurrency(conference, selectedCurrency);
        // Check if the workshop is already selected
        const isAlreadySelected = selectedConferences.some(
            (selectedConference) => selectedConference.id === id
        );

        if (event.target.checked && !isAlreadySelected) {
            // Generate a unique color for the row based on specific fields
            const uniqueColor = getColorForFields(conference_day, confernce_date, conference_start_time);

            setSelectedConferences([...selectedConferences, conference]);
            setSelectedConferenceAmounts([...selectedConferenceAmounts, { id, confernce_date, conference_amount, conference_name, conference_day, conference_coupon }]);

            // Update the color map with the unique color for the specific row values
            setColorMap(prevColorMap => ({
                ...prevColorMap,
                [`${conference_day}-${confernce_date}-${conference_start_time}`]: uniqueColor,
            }));
        } else if (!event.target.checked && isAlreadySelected) {
            setSelectedConferences(selectedConferences.filter((w) => w.id !== id));

            // Remove the item with the matching id
            setSelectedConferenceAmounts(selectedConferenceAmounts.filter((item) => item.id !== id));

            // Clear the color map entry when the row is unchecked
            setColorMap(prevColorMap => {
                const newColorMap = { ...prevColorMap };
                delete newColorMap[`${conference_day}-${confernce_date}-${conference_start_time}`];
                return newColorMap;
            });
        }
    };
    const handleCurrencyChange = (event) => {
        const newCurrency = event.target.value;
        setSelectedCurrency(newCurrency);

        // Clear all selections when currency changes
        setSelectedConferences([]);
        setSelectedConferenceAmounts([]);
        setColorMap({});


    };

    // Helper function to get price by currency
    const getPriceByCurrency = (conference, currency) => {
        switch (currency) {
            case 'SAR':
                return conference.conference_amount;
            case 'ARE':
                return conference.conference_aed_price;
            case 'USA':
                return conference.conference_doller_price;
            default:
                return conference.conference_amount;
        }
    };

    const isCheckboxDisabled = (conference) => {

        const {
            id,
            conference_day,
            conference_category_id,
            conference_date,
            conference_end_date,
            conference_start_time,
            conference_end_time,
            conference_no_ofseats,
        } = conference;

        // Check if another conference with the same values is already selected
        const isAlreadySelected = selectedConferences.some(
            (selectedConference) =>
                selectedConference.conference_category_id === conference_category_id &&
                selectedConference.conference_day === conference_day &&
                selectedConference.conference_date === conference_date &&
                selectedConference.conference_start_time === conference_start_time &&
                selectedConference.conference_end_time === conference_end_time &&
                selectedConference.id !== id
        );

        // Check if the conference time has passed
        // const conferenceDateTime = new Date(`${conference_date}T${conference_start_time}`).getTime();
        // const currentDateTime = new Date().getTime();
        // const isTimePassed = conferenceDateTime < currentDateTime;

        const conferenceDateTime = new Date(`${conference_end_date}T${conference_end_time}`).getTime();
        const currentDateTime = new Date().getTime();
        const isTimePassed = conferenceDateTime < currentDateTime;

        // Check if the seat limit has been reached
        const conferenceIdToMatch = conference.id;


        const countConferences = Array.isArray(conferenceTotalSeatCount)
            ? conferenceTotalSeatCount.filter((c) => c?.conference_id === conferenceIdToMatch).length
            : 0;
        const isSeatLimitReached = countConferences >= parseInt(conference_no_ofseats, 10);




        // Build messages
        let seatLimitMessage = '';
        if (isSeatLimitReached) {
            //seatLimitMessage = `All (${countConferences}) seats are full, please uncheck and proceed.`;
            seatLimitMessage = `All (${countConferences}) seats are full.`;
        }

        let timeOffMessage = '';
        if (isTimePassed) {
            timeOffMessage = `Expired`;
        }

        // Combine all conditions
        const isDisabled = isAlreadySelected || isTimePassed || isSeatLimitReached;

        // Assign color
        const color = colorMap[`${conference_day}-${conference_date}-${conference_start_time}`] || '#fff';

        return { isDisabled, color, seatLimitMessage, timeOffMessage };
    };



    // Function to generate a unique color based on specific fields
    const getColorForFields = (url, date, startTime) => {
        return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    };

    useEffect(() => {

        Object.keys(discountMessages).forEach(workshopId => {

        });
    }, [discountMessages]);

    useEffect(() => {

    }, [totalAmount]);

    const [fullDiscountApplied, setFullDiscountApplied] = useState(false);
    useEffect(() => {
        const newTotalAmount = selectedConferenceAmounts.reduce((acc, conference) => {

            let discount = 0;

            const singleWorkshopAmount = Number(conference.conference_amount);
            const matchingCoupon = couponCodes.find(couponValue => inputValues[conference.id] === couponValue.coupon_code);
            const useCoupon = conferenceUsedCoupeon.filter(couponsVal => inputValues[conference.id] === couponsVal.coupon_code);

            // Clear previous messages if coupon changes
            if (!matchingCoupon) {
                setUsedCouponMessage(prevMessages => {
                    const updatedMessages = { ...prevMessages };
                    delete updatedMessages[conference.id]; // Remove the message for this conference
                    return updatedMessages;
                });
            }

            if (matchingCoupon) {
                if (matchingCoupon.coupon_amout_type === "percentage" && conference.id === matchingCoupon.conference_id &&
                    inputValues[conference.id] === matchingCoupon.coupon_code) {
                    if (useCoupon.length > 0) {
                        const messageUsedCoupon = 'The Coupon is Already used';
                        setUsedCouponMessage(prevMessages => ({ ...prevMessages, [conference.id]: messageUsedCoupon }));
                    } else {
                        const currentDate = new Date();
                        const currentFormattedDate = currentDate.toISOString().split('T')[0];
                        const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;

                        if (isTimePassedExpired) {
                            const messageUsedCoupon = 'The Coupon is Expired';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [conference.id]: messageUsedCoupon }));
                        } else {
                            discount = (singleWorkshopAmount * matchingCoupon.coupon_amout_value) / 100;
                            if (parseFloat(matchingCoupon.coupon_amout_value) === 100) {
                                setFullDiscountApplied(true); // ✅ No error now
                            }
                            console.log("fullDiscountApplied", fullDiscountApplied);
                            console.log("discount", discount);
                            console.log("matchingCoupon.coupon_amout_value", matchingCoupon.coupon_amout_value);
                            console.log("singleConferenceAmount", singleWorkshopAmount);
                        }
                    }
                } else if (matchingCoupon.coupon_amout_type === "fixed" && conference.id === matchingCoupon.conference_id &&
                    inputValues[conference.id] === matchingCoupon.coupon_code) {
                    if (useCoupon.length > 0) {
                        const messageUsedCoupon = 'The Coupon is Already used';
                        setUsedCouponMessage(prevMessages => ({ ...prevMessages, [conference.id]: messageUsedCoupon }));
                    } else {
                        const currentDate = new Date();
                        const currentFormattedDate = currentDate.toISOString().split('T')[0];
                        const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;

                        if (isTimePassedExpired) {
                            const messageUsedCoupon = 'The Coupon is Expired';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [conference.id]: messageUsedCoupon }));
                        } else {
                            discount = matchingCoupon.coupon_amout_value;
                        }
                    }
                }

                if (!isNaN(singleWorkshopAmount) && discount > 0) {
                    const message = `Discount applied for conference ${conference.id}. Coupon Code: ${inputValues[conference.id]}`;
                    setDiscountMessages(prevMessages => ({ ...prevMessages, [conference.id]: message }));
                    setDisabledInputs(prevDisabled => ({ ...prevDisabled, [conference.id]: true }));
                }
            }

            return acc + (singleWorkshopAmount - discount);
        }, 0);

        setTotalAmount(newTotalAmount);
    }, [selectedConferenceAmounts, couponCodes, inputValues]);


    const toggleCouponInput = (workshopId) => {
        setShowCouponInputs((prevState) => ({
            ...prevState,
            [workshopId]: !prevState[workshopId],
        }));
    };

    // const handleInput = (e) => {
    //     const value = e.target.value;
    //     const inputName = e.target.name;

    //     setAddConferenceParticpant({ ...addConferenceParticpant, [e.target.name]: e.target.value });
    //     localStorage.setItem(inputName, value);

    // }
    const handleInput = (e) => {
        const value = e.target.value;
        const inputName = e.target.name;

        setAddConferenceParticpant(prev => {
            let newErrorList = { ...prev.error_list };

            if (inputName === "password") {
                if (!value) {
                    newErrorList.participant_password = ["Password is required"];
                } else if (value.length < 8) {
                    newErrorList.participant_password = ["Password must be at least 8 characters"];
                } else {
                    newErrorList.participant_password = [];
                }
            }

            return {
                ...prev,
                [inputName]: value,
                error_list: newErrorList
            };
        });

        localStorage.setItem(inputName, value);
    };


    const handleCountry = (e) => {
        const selectCountry = e.target.value;
        setCountry(selectCountry);
        localStorage.setItem('selectedCountry', selectCountry);
    }

    // const handleChange = (event) => {

    //     setGender(event.target.value);
    //     localStorage.setItem(event.target.value);
    // };
    const handleChange = (event) => {
        const selectedGender = event.target.value;
        setGender(selectedGender);
        localStorage.setItem('gender', selectedGender);
    };

    // Function to handle radio button change


    const handleNameTitle = (e) => {
        const selectNametitle = e.target.value;

        setNameTitle(selectNametitle);
        localStorage.setItem('nameTitle', selectNametitle)
    }

    const isFormValid = () => {
        return (
            nameTitle &&
            addConferenceParticpant.conference_partecpant_name &&
            addConferenceParticpant.saudiCouncilno &&
            registrationType &&
            (addConferenceParticpant.participant_email || conference_particpant_email) &&
            addConferenceParticpant.phone &&
            addConferenceParticpant.password &&
            addConferenceParticpant.password.length >= 8 &&
            addConferenceParticpant.profession &&
            gender !== "" &&
            country &&
            addConferenceParticpant.city
        );
    };

    const handleNextClick = () => {
        if (isFormValid()) {
            handleNext();
        } else {
            // show error messages manually
            setAddConferenceParticpant(prev => ({
                ...prev,
                error_list: {
                    ...prev.error_list,
                    name_title: !nameTitle ? "Title is required" : "",
                    participant_name: !addConferenceParticpant.conference_partecpant_name ? "Name is required" : "",
                    participant_saudi_council_no: AsActiveSaudiCouncilNo === 1 && !addConferenceParticpant.saudiCouncilno ? "Saudi Council No is required" : "",
                    participant_conference_categoy: !registrationType ? "Conference category is required" : "",
                    participant_email: !(addConferenceParticpant.participant_email || conference_particpant_email) ? "Email is required" : "",

                    participant_password:
                        !addConferenceParticpant.password
                            ? ["Password is required"]
                            : addConferenceParticpant.password.length < 8
                                ? ["Password must be at least 8 characters"]
                                : [],
                    participant_contact: !addConferenceParticpant.phone ? "Mobile is required" : "",
                    participant_profession: !addConferenceParticpant.profession ? "Profession is required" : "",
                    participant_gender: gender === "" ? "Gender is required" : "",
                    // Add others if needed
                }
            }));
        }
    };


    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);

    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleExtraButtonClick = () => {
        // Move back to Step 1
        setActiveStep(0);
    };

    const handleInputChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value,
        }));
    };

    const { error_list } = addConferenceParticpant;
    const handleSubmitBank = (e) => {
        e.preventDefault();
        setLoading(true); // Set loading state to true when button is clicked
        const paymentBank = "paymentBank";
        if (agree === false) {
            swal('Warning', 'Please agree to the terms and conditions before proceeding.', 'warning');
            setLoading(false); // Set loading state back to false if not agreed
            return;
        }

        const data = {
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: addConferenceParticpant.saudiCouncilno,
            participant_name: addConferenceParticpant.conference_partecpant_name,
            participant_email: addConferenceParticpant.participant_email === "" ? conference_particpant_email : addConferenceParticpant.participant_email,
            participant_conference_categoy: singleConferenceCategory.id,
            participant_contact: addConferenceParticpant.phone,
            participant_password: addConferenceParticpant.password,
            participant_profession: addConferenceParticpant.profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: addConferenceParticpant.city,
            participant_hostpital_organization: addConferenceParticpant.hostpital_organization,
            participant_level: addConferenceParticpant.level_of_education,
            selectedConferenceAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentBank,
            //event_affiliate_status,
            ...(event_affiliate_status !== null && { event_affiliate_status }),


        };


        {
            data.eventid == "" ? setLoading(false) : data.name_title == "" ? setLoading(false) :
                data.participant_saudi_council_no == "" ? setLoading(false) : data.participant_name == "" ? setLoading(false) :
                    data.participant_email == "" ? setLoading(false) : data.participant_conference_categoy == "" ? setLoading(false) :
                        data.participant_contact == "" ? setLoading(false) : data.participant_profession == "" ? setLoading(false) :
                            data.participant_gender == "" ? setLoading(false) : data.participant_country == "" ? setLoading(false) :
                                data.selectedConferenceAmounts == "" ? setLoading(false) :
                                    data.totalAmount == "" ? setLoading(false) : data.paymentBank == "" ? setLoading(false) : setLoading(true)
        }


        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/conference-particpant-regisrtation`, data, config).then(res => {

                if (res.data.status === 200) {
                    const participantId = res.data.participantId;

                    swal('Success', res.data.message, 'success');

                    // history.push('/workshop/particpant-form/thank-you');
                    history.push(`/conference/thank-you/${participantId}`);

                    return false;
                }
                else {
                    setLoading(false);
                    setAddConferenceParticpant({ ...addConferenceParticpant, error_list: res.data.validate_error })

                }

            }).catch(error => {
                setLoading(false); // Set loading state back to false in case of error
                console.error('Error:', error);
            });
        }).catch(error => {
            setLoading(false); // Set loading state back to false in case of error
            console.error('Error:', error);
        });
    };

    const dynamicColor = abstractHomeSetup?.color_code_two || gradientBackground; // fallback color
    // Create a style tag dynamically with your color
    const styleTag = document.createElement('style');
    styleTag.innerHTML = `
  .custom-button {
    background-color: ${dynamicColor} !important;
    color: white !important;
    padding: 10px 20px !important;
    border: none !important;
    border-radius: 5px !important;
    cursor: pointer !important;
    font-size: 16px !important;
  }
`;
    document.head.appendChild(styleTag);

    const handleSubmitAffiliate = (e) => {
        e.preventDefault();
        setLoading(true); // Set loading state to true when button is clicked

        const paymentOnline = "paymentOnline";
        if (agree === false) {
            swal('Warning', 'Please agree to the terms and conditions before proceeding.', 'warning');
            setLoading(false); // Set loading state back to false if not agreed
            return;
        }
        const data = {
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: addConferenceParticpant.saudiCouncilno,
            participant_name: addConferenceParticpant.conference_partecpant_name,
            participant_email: addConferenceParticpant.participant_email === "" ? conference_particpant_email : addConferenceParticpant.participant_email,
            participant_conference_categoy: singleConferenceCategory.id,
            participant_contact: addConferenceParticpant.phone,
            participant_password: addConferenceParticpant.password,
            participant_profession: addConferenceParticpant.profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: addConferenceParticpant.city,
            participant_hostpital_organization: addConferenceParticpant.hostpital_organization,
            participant_level: addConferenceParticpant.level_of_education,
            selectedConferenceAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentOnline,
            event_affiliate_status,
            currencyIsPay: selectedCurrency, // Add the selected currency to the data object
        };
        console.log("data", data);
        {
            data.eventid == "" ? setLoading(false) : data.name_title == "" ? setLoading(false) :
                data.participant_saudi_council_no == "" ? setLoading(false) : data.participant_name == "" ? setLoading(false) :
                    data.participant_email == "" ? setLoading(false) : data.participant_conference_categoy == "" ? setLoading(false) :
                        data.participant_contact == "" ? setLoading(false) : data.participant_profession == "" ? setLoading(false) :
                            data.participant_gender == "" ? setLoading(false) : data.participant_country == "" ? setLoading(false) :
                                data.selectedConferenceAmounts == "" ? setLoading(false) :
                                    data.totalAmount == "" ? setLoading(false) : data.paymentOnline == "" ? setLoading(false) : setLoading(true)
        }

        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/onlinepayment-conference-particpant-store`, data, config).then(res => {
                setLoading(false); // Set loading state back to false after operation completes
                if (res.data.status === 200) {
                    const participantId = res.data.participantId;
                    swal('Success', res.data.message, 'success');

                    //console.log("res" ,res)
                    window.location.href = res.data.redirect.redirect_url;
                } else {
                    setAddConferenceParticpant({ ...addConferenceParticpant, error_list: res.data.validate_error });
                }
            }).catch(error => {
                setLoading(false); // Set loading state back to false in case of error
                console.error('Error:', error);
            });
        }).catch(error => {
            setLoading(false); // Set loading state back to false in case of error
            console.error('Error:', error);
        });
        //});
    }





    const handleSubmitOnline = (e) => {
        e.preventDefault();
        setLoading(true); // Set loading state to true when button is clicked


        const paymentOnline = "paymentOnline";
        if (agree === false) {
            swal('Warning', 'Please agree to the terms and conditions before proceeding.', 'warning');
            setLoading(false); // Set loading state back to false if not agreed
            return;
        }
        const data = {
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: addConferenceParticpant.saudiCouncilno,
            participant_name: addConferenceParticpant.conference_partecpant_name,
            participant_email: addConferenceParticpant.participant_email === "" ? conference_particpant_email : addConferenceParticpant.participant_email,
            participant_conference_categoy: singleConferenceCategory.id,
            participant_password: addConferenceParticpant.password,
            participant_contact: addConferenceParticpant.phone,
            participant_profession: addConferenceParticpant.profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: addConferenceParticpant.city,
            participant_hostpital_organization: addConferenceParticpant.hostpital_organization,
            participant_level: addConferenceParticpant.level_of_education,
            selectedConferenceAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentOnline,
            currencyIsPay: selectedCurrency, // Add the selected currency to the data object
        };
        // console.log("data", data);
        {
            data.eventid == "" ? setLoading(false) : data.name_title == "" ? setLoading(false) :
                data.participant_saudi_council_no == "" ? setLoading(false) : data.participant_name == "" ? setLoading(false) :
                    data.participant_email == "" ? setLoading(false) : data.participant_conference_categoy == "" ? setLoading(false) :
                        data.participant_contact == "" ? setLoading(false) : data.participant_profession == "" ? setLoading(false) :
                            data.participant_gender == "" ? setLoading(false) : data.participant_country == "" ? setLoading(false) :
                                data.selectedConferenceAmounts == "" ? setLoading(false) :
                                    data.totalAmount == "" ? setLoading(false) : data.paymentOnline == "" ? setLoading(false) : setLoading(true)
        }

        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/onlinepayment-conference-particpant-store`, data, config).then(res => {
                setLoading(false); // Set loading state back to false after operation completes
                if (res.data.status === 200) {
                    // const participantId = res.data.participantId;
                    swal('Success', res.data.message, 'success');
                    console.log("Redirect URL:", res.data.redirect);

                    //console.log("res" ,res)
                    window.location.href = res.data.redirect.redirect_url;

                } else {
                    setLoading(false);
                    setAddConferenceParticpant({ ...addConferenceParticpant, error_list: res.data.validate_error });
                }
            }).catch(error => {
                setLoading(false); // Set loading state back to false in case of error
                console.error('Error:', error);
            });
        }).catch(error => {
            setLoading(false); // Set loading state back to false in case of error
            console.error('Error:', error);
        });
        // });
    };

    const handleSubmitCash = (e) => {
        e.preventDefault();
        const paymentCash = "paymentCash";
        if (agree === false) {
            swal('Warning', 'Please agree to the terms and conditions before proceeding.', 'warning');
            setLoading(false); // Set loading state back to false if not agreed
            return;
        }
        const data = {
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: addConferenceParticpant.saudiCouncilno,
            participant_name: addConferenceParticpant.conference_partecpant_name,
            participant_email: addConferenceParticpant.participant_email === "" ? conference_particpant_email : addConferenceParticpant.participant_email,
            participant_conference_categoy: singleConferenceCategory.id,
            participant_contact: addConferenceParticpant.phone,
            participant_password: addConferenceParticpant.password,
            participant_profession: addConferenceParticpant.profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: addConferenceParticpant.city,
            participant_hostpital_organization: addConferenceParticpant.hostpital_organization,
            participant_level: addConferenceParticpant.level_of_education,
            selectedConferenceAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentCash,

        };
        {
            data.eventid == "" ? setLoading(false) : data.name_title == "" ? setLoading(false) :
                data.participant_saudi_council_no == "" ? setLoading(false) : data.participant_name == "" ? setLoading(false) :
                    data.participant_email == "" ? setLoading(false) : data.participant_conference_categoy == "" ? setLoading(false) :
                        data.participant_contact == "" ? setLoading(false) : data.participant_profession == "" ? setLoading(false) :
                            data.participant_gender == "" ? setLoading(false) : data.participant_country == "" ? setLoading(false) :
                                data.selectedConferenceAmounts == "" ? setLoading(false) :
                                    data.totalAmount == "" ? setLoading(false) : data.paymentCash == "" ? setLoading(false) : setLoading(true)
        }

        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/conference-particpant-regisrtation`, data, config).then(res => {

                if (res.data.status === 200) {
                    const participantId = res.data.participantId;

                    swal('Success', res.data.message, 'success');
                    history.push(`/conference/thank-you/${participantId}`);
                    return false;
                }
                else {

                    setAddConferenceParticpant({ ...addConferenceParticpant, error_list: res.data.validate_error })

                }

            });


        });



    };

    const handleSubmitFree = (e) => {
        e.preventDefault();

        const paymentFree = "paymentFree";
        if (agree === false) {
            swal('Warning', 'Please agree to the terms and conditions before proceeding.', 'warning');
            setLoading(false); // Set loading state back to false if not agreed
            return;
        }
        const data = {
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: addConferenceParticpant.saudiCouncilno,
            participant_name: addConferenceParticpant.conference_partecpant_name,
            participant_email: addConferenceParticpant.participant_email === "" ? conference_particpant_email : addConferenceParticpant.participant_email,
            participant_conference_categoy: singleConferenceCategory.id,
            participant_contact: addConferenceParticpant.phone,
            participant_password: addConferenceParticpant.password,
            participant_profession: addConferenceParticpant.profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: addConferenceParticpant.city,
            participant_hostpital_organization: addConferenceParticpant.hostpital_organization,
            participant_level: addConferenceParticpant.level_of_education,
            selectedConferenceAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentFree,
            event_affiliate_status,


        };


        {
            data.eventid == "" ? setLoading(false) : data.name_title == "" ? setLoading(false) : data.participant_name == "" ? setLoading(false)
                : data.participant_saudi_council_no == "" ? setLoading(false) : data.participant_email == "" ? setLoading(false)
                    : data.participant_conference_categoy == "" ? setLoading(false) : data.participant_contact == "" ? setLoading(false)
                        : data.participant_profession == "" ? setLoading(false) : data.participant_gender == "" ? setLoading(false)
                            : data.paymentFree == "" ? setLoading(false) : setLoading(true)
        }
        //setLoading(true)
        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/conference-particpant-free-regisrtation`, data, config).then(res => {

                if (res.data.status === 200) {
                    const participantId = res.data.participantId;
                    const badge_url = res.data.badge_link;
                    swal('Success', res.data.message, 'success');
                    history.push({
                        pathname: `/conference/thank-you/${participantId}`,
                        state: { badge_url }
                    });
                    //history.push(`/conference/thank-you/${participantId}`);
                    return false;
                }
                else {

                    setAddConferenceParticpant({ ...addConferenceParticpant, error_list: res.data.validate_error })

                }

            });


        });
    }



    //const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isMobile = useMediaQuery('(max-width:600px)');
    const renderSelectedConferenceInfo = () => {

        // const handleRemoveConference = (ConferenceIdToRemove) => {
        //     const updatedConferences = selectedConferenceAmounts.filter(conference => conference.id !== ConferenceIdToRemove);
        //     setSelectedConferenceAmounts(updatedConferences);
        // }
        const handleRemoveConference = (conferenceIdToRemove) => {
            // Remove the conference from selectedConferenceAmounts
            const updatedConferenceAmounts = selectedConferenceAmounts.filter(conference => conference.id !== conferenceIdToRemove);
            setSelectedConferenceAmounts(updatedConferenceAmounts);

            // Remove the conference from selectedConferences
            const updatedSelectedConferences = selectedConferences.filter(conference => conference.id !== conferenceIdToRemove);
            setSelectedConferences(updatedSelectedConferences);
        };



        return (
            <div>
                <TableContainer component={Paper}>

                    <Table>
                        <TableHead>
                            <TableRow>
                                {isMobile ? (
                                    <TableCell colSpan={5} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        Conference Details
                                    </TableCell>
                                ) : (
                                    <>
                                        <TableCell>Conference Name</TableCell>
                                        <TableCell>Conference Day</TableCell>
                                        <TableCell>Coupon</TableCell>
                                        <TableCell></TableCell>
                                        <TableCell align="right">Conference Amount </TableCell>
                                        <TableCell align="right">Action</TableCell>
                                    </>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {selectedConferenceAmounts && selectedConferenceAmounts.map((selectedConference, index) => (
                                <TableRow key={selectedConference.id}>
                                    {/* //selectedConference */}

                                    {isMobile ? (
                                        <>
                                            <TableCell style={{ display: 'flex', flexWrap: 'wrap', flexBasis: '100%' }}>
                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                    <strong>No:  {index + 1} </strong>
                                                    <hr></hr>
                                                </Box>
                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                    <strong>Conference Name:</strong> {selectedConference.conference_name}
                                                </Box>
                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                    <strong>Conference Day:</strong> {selectedConference.conference_day}
                                                </Box>
                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                    <strong>Coupon:</strong>
                                                    {selectedConference.conference_coupon === 1 && (
                                                        <Checkbox
                                                            checked={!!showCouponInputs[selectedConference.id]}  // Use !! to convert to boolean
                                                            onChange={() => toggleCouponInput(selectedConference.id)}
                                                        />
                                                    )}

                                                    {/* Coupon Input */}

                                                    {showCouponInputs[selectedConference.id] && selectedConference.conference_coupon === 1 && (
                                                        <Input
                                                            type="text"
                                                            placeholder="Your Coupon Code"
                                                            value={inputValues[selectedConference.id] || ''}
                                                            onChange={(e) => handleCouponCodeChange(selectedConference.id, e.target.value)}
                                                        //disabled={!!discountMessages[selectedConference.id]} // Disable when discount is applied
                                                        />
                                                    )}


                                                    {/* Success Message */}
                                                    {discountMessages[selectedConference.id] && (
                                                        <div>
                                                            <h3 style={{ color: "green" }}>Coupon Applied</h3>
                                                        </div>
                                                    )}

                                                    {/* Incorrect Coupon Message */}
                                                    {!discountMessages[selectedConference.id] && usedCouponMessage[selectedConference.id] === 'The Coupon is not correct' && (
                                                        <div>
                                                            <h3 style={{ color: "red" }}>{usedCouponMessage[selectedConference.id]}</h3>
                                                        </div>
                                                    )}

                                                    {/* Error or Other Info Message */}
                                                    {!discountMessages[selectedConference.id] && usedCouponMessage[selectedConference.id] && usedCouponMessage[selectedConference.id] !== 'The Coupon is not correct' && (
                                                        <div>
                                                            <h3 style={{ color: "orange" }}>{usedCouponMessage[selectedConference.id]}</h3>
                                                        </div>
                                                    )}

                                                    {/* Default Message (Optional) */}
                                                    {!discountMessages[selectedConference.id] && !usedCouponMessage[selectedConference.id] && (
                                                        <div>
                                                            <h3 style={{ color: "gray" }}>Enter a valid coupon code.</h3>
                                                        </div>
                                                    )}

                                                </Box>
                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                    <strong>Conference Price ({selectedCurrency}):</strong> {selectedConference.conference_amount}
                                                </Box>


                                                <Box style={{ flexBasis: '100%', margin: '5px' }} align="right">
                                                    <TableCell >
                                                        {/* Remove button with onClick event */}
                                                        <Button onClick={() => handleRemoveConference(selectedConference.id)}>Remove</Button>
                                                    </TableCell>
                                                </Box>
                                            </TableCell>
                                        </>
                                    ) : (
                                        <>
                                            <TableCell>{selectedConference.conference_name}</TableCell>
                                            <TableCell>{selectedConference.conference_day}</TableCell>
                                            <TableCell>
                                                {selectedConference.conference_coupon === 1 && (
                                                    <Checkbox
                                                        checked={!!showCouponInputs[selectedConference.id]}  // Use !! to convert to boolean
                                                        onChange={() => toggleCouponInput(selectedConference.id)}
                                                    />
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {/* Coupon Input */}
                                                {showCouponInputs[selectedConference.id] && selectedConference.conference_coupon === 1 && (
                                                    <Input
                                                        type="text"
                                                        placeholder="Your Coupon Code"
                                                        value={inputValues[selectedConference.id] || ''}
                                                        onChange={(e) => handleCouponCodeChange(selectedConference.id, e.target.value)}
                                                    //disabled={!!discountMessages[selectedConference.id]} // Disable when discount is applied
                                                    />
                                                )}

                                                {/* Success Message */}
                                                {discountMessages[selectedConference.id] && (
                                                    <div>
                                                        <h3 style={{ color: "green" }}>Coupon Applied</h3>
                                                    </div>
                                                )}

                                                {/* Incorrect Coupon Message */}
                                                {!discountMessages[selectedConference.id] && usedCouponMessage[selectedConference.id] === 'The Coupon is not correct' && (
                                                    <div>
                                                        <h3 style={{ color: "red" }}>{usedCouponMessage[selectedConference.id]}</h3>
                                                    </div>
                                                )}

                                                {/* Error or Other Info Message */}
                                                {!discountMessages[selectedConference.id] && usedCouponMessage[selectedConference.id] && usedCouponMessage[selectedConference.id] !== 'The Coupon is not correct' && (
                                                    <div>
                                                        <h3 style={{ color: "orange" }}>{usedCouponMessage[selectedConference.id]}</h3>
                                                    </div>
                                                )}

                                                {/* Default Message (Optional) */}
                                                {!discountMessages[selectedConference.id] && !usedCouponMessage[selectedConference.id] && (
                                                    <div>
                                                        <h3 style={{ color: "gray" }}>Enter a valid coupon code.</h3>
                                                    </div>
                                                )}
                                            </TableCell>

                                            <TableCell align="right">{selectedConference.conference_amount}</TableCell>
                                            <TableCell align="right">
                                                {/* Remove button with onClick event */}
                                                <Button onClick={() => handleRemoveConference(selectedConference.id)}>Remove</Button>
                                            </TableCell>
                                        </>
                                    )}
                                </TableRow>
                            ))}
                            <TableCell colSpan={5} align="right" style={{ fontWeight: 'bold' }}> Amount: {totalAmount} </TableCell>

                            <TableRow>
                                <TableCell
                                    colSpan={isMobile ? 1 : 3}
                                    align={isMobile ? 'left' : 'left'}
                                >
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={agree}
                                                onChange={(e) => setAgree(e.target.checked)}
                                                color="primary"
                                            />
                                        }
                                        label={
                                            <Typography variant="body2">
                                                I agree to the&nbsp;
                                                {/* <a   href="#/conference/terms-and-conditions" target="_blank" rel="noopener noreferrer">
                                                    Terms&nbsp;and&nbsp;Conditions
                                                </a> */}
                                                <a
                                                    href="#/conference/terms-and-conditions"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    onClick={(e) => {
                                                        // Store current scroll position
                                                        sessionStorage.setItem('returnScrollPosition', window.scrollY.toString());
                                                    }}
                                                >
                                                    Terms&nbsp;and &nbsp; Conditions
                                                </a>
                                            </Typography>
                                        }
                                    />
                                    <Typography variant="body2" color="error">
                                        Tax applicable will be add in the next step
                                    </Typography>

                                </TableCell>
                            </TableRow>
                        </TableBody>

                    </Table>

                </TableContainer>
                <Box noValidate sx={{ mt: 1, display: 'flex', justifyContent: 'flex-end' }}>
                    {isMobile ? (
                        <>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center', marginTop: "20px", }}>
                                {
                                    event_affiliate_status ? (
                                        <>
                                            {abstractHomeSetup.c_free_status == 1 ? (
                                                // Only Register button if free status is 1 
                                                <Button
                                                    onClick={handleSubmitFree}
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: abstractHomeSetup.color_code_two
                                                            ? abstractHomeSetup.color_code_two
                                                            : gradientBackground,
                                                        flex: '1 1 48%',
                                                    }}
                                                    disabled={loading}
                                                >
                                                    {loading ? 'Loading...' : 'Register'}
                                                </Button>
                                            ) : (
                                                // Show both other buttons if free status is NOT 1
                                                <>
                                                    <Button
                                                        onClick={handleSubmitAffiliate}
                                                        variant="contained"
                                                        sx={{
                                                            backgroundColor: abstractHomeSetup.color_code_two
                                                                ? abstractHomeSetup.color_code_two
                                                                : gradientBackground,
                                                            flex: '1 1 48%',
                                                        }}
                                                        disabled={loading}
                                                    >
                                                        {loading ? 'Loading...' : 'Affiliation Discount Online'}
                                                    </Button>

                                                </>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            {totalAmount > 0 && abstractHomeSetup.c_bank_status == 1 && (
                                                <Button
                                                    onClick={handleSubmitBank}
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: abstractHomeSetup.color_code_two
                                                            ? abstractHomeSetup.color_code_two
                                                            : gradientBackground,
                                                        flex: '1 1 48%',
                                                    }}
                                                    disabled={loading}
                                                >
                                                    {loading ? 'Loading...' : 'Bank'}
                                                </Button>
                                            )}

                                            {totalAmount > 0 && abstractHomeSetup.c_cash_status == 1 && (
                                                <Button
                                                    onClick={handleSubmitCash}
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: abstractHomeSetup.color_code_two
                                                            ? abstractHomeSetup.color_code_two
                                                            : gradientBackground,
                                                        flex: '1 1 48%',
                                                    }}
                                                    disabled={loading}
                                                >
                                                    {loading ? 'Loading...' : 'Cash'}
                                                </Button>
                                            )}

                                            {abstractHomeSetup.c_free_status == 1 && (
                                                <Button
                                                    onClick={handleSubmitFree}
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: abstractHomeSetup.color_code_two
                                                            ? abstractHomeSetup.color_code_two
                                                            : gradientBackground,
                                                        flex: '1 1 48%',
                                                    }}
                                                    disabled={loading}
                                                >
                                                    {loading ? 'Loading...' : 'Register'}
                                                </Button>
                                            )}
                                            {totalAmount > 0 && abstractHomeSetup.c_online_status == 1 && (
                                                <Button
                                                    onClick={handleSubmitOnline}
                                                    variant="contained"
                                                    sx={{
                                                        flex: '1 1 48%',

                                                        backgroundColor: abstractHomeSetup.color_code_two
                                                            ? abstractHomeSetup.color_code_two
                                                            : gradientBackground,
                                                    }}
                                                    disabled={loading}
                                                >
                                                    {loading ? 'Loading...' : 'Online'}
                                                </Button>)}

                                        </>
                                    )}


                            </div>
                        </>
                    ) : (
                        <>

                            {
                                event_affiliate_status ? (
                                    <>{abstractHomeSetup.c_free_status == 1 ? (
                                        // Only Register button if free status is 1
                                        <Button
                                            onClick={handleSubmitFree}
                                            variant="contained"
                                            sx={{
                                                mt: 3,
                                                mb: 2,
                                                backgroundColor: abstractHomeSetup.color_code_two
                                                    ? abstractHomeSetup.color_code_two
                                                    : gradientBackground,
                                            }}
                                            disabled={loading}
                                        >
                                            {loading ? 'Loading...' : 'Register'}
                                        </Button>
                                    ) : (
                                        // Show both other buttons if free status is NOT 1
                                        <>
                                            <Button
                                                onClick={handleSubmitAffiliate}
                                                variant="contained"
                                                sx={{
                                                    mt: 3,
                                                    mb: 2,
                                                    ml: 4,
                                                    mr: 2,
                                                    backgroundColor: abstractHomeSetup.color_code_two
                                                        ? abstractHomeSetup.color_code_two
                                                        : gradientBackground,
                                                }}
                                                disabled={loading}
                                            >
                                                {loading ? 'Loading...' : 'Affiliation Discount Online'}
                                            </Button>

                                        </>
                                    )}
                                    </>
                                ) : (
                                    <>
                                        {totalAmount > 0 && abstractHomeSetup.c_online_status == 1 && (
                                            <Button
                                                onClick={handleSubmitOnline}
                                                variant="contained"
                                                sx={{
                                                    mt: 3,
                                                    mb: 2,
                                                    ml: 4,
                                                    mr: 2,
                                                    backgroundColor: abstractHomeSetup.color_code_two
                                                        ? abstractHomeSetup.color_code_two
                                                        : gradientBackground,
                                                }}
                                                disabled={loading}
                                            >
                                                {loading ? 'Loading...' : 'Online'}
                                            </Button>
                                        )}

                                        {totalAmount > 0 && abstractHomeSetup.c_bank_status == 1 && (
                                            <Button
                                                onClick={handleSubmitBank}
                                                variant="contained"
                                                sx={{
                                                    mt: 3,
                                                    mb: 2,
                                                    mr: 2,
                                                    backgroundColor: abstractHomeSetup.color_code_two
                                                        ? abstractHomeSetup.color_code_two
                                                        : gradientBackground,
                                                }}
                                                disabled={loading}
                                            >
                                                {loading ? 'Loading...' : 'Bank'}
                                            </Button>
                                        )}

                                        {totalAmount > 0 && abstractHomeSetup.c_cash_status == 1 && (
                                            <Button
                                                onClick={handleSubmitCash}
                                                variant="contained"
                                                sx={{
                                                    mt: 3,
                                                    mb: 2,
                                                    mr: 2,
                                                    backgroundColor: abstractHomeSetup.color_code_two
                                                        ? abstractHomeSetup.color_code_two
                                                        : gradientBackground,
                                                }}
                                                disabled={loading}
                                            >
                                                {loading ? 'Loading...' : 'Cash'}
                                            </Button>
                                        )}

                                        {abstractHomeSetup.c_free_status == 1 && (
                                            <Button
                                                onClick={handleSubmitFree}
                                                variant="contained"
                                                sx={{
                                                    mt: 3,
                                                    mb: 2,
                                                    backgroundColor: abstractHomeSetup.color_code_two
                                                        ? abstractHomeSetup.color_code_two
                                                        : gradientBackground,
                                                }}
                                                disabled={loading}
                                            >
                                                {loading ? 'Loading...' : 'Register'}
                                            </Button>
                                        )}
                                    </>
                                )
                            }



                        </>
                    )}
                    {
                        fullDiscountApplied && totalAmount === 0 && (
                            <Button
                                onClick={handleSubmitFree}
                                variant="contained"
                                sx={{
                                    mt: 3,
                                    mb: 2,
                                    backgroundColor: abstractHomeSetup.color_code_two || gradientBackground,
                                }}
                                disabled={loading}
                            >
                                {loading ? 'Loading...' : 'Register'}
                            </Button>
                        )
                    }

                </Box>

            </div>
        );
    };


    return (
        <div>
            <Grid item xs={12} sm={10} md={8} lg={6}>
                <ConferenceNavbar />
            </Grid>
            <Grid container spacing={2} >
                <Box
                    sx={{
                        position: 'relative',
                        marginTop: '10px',
                        width: '100%',
                        height: isSmallScreen ? '200px' : '300px',

                        backgroundImage: `url(${(abstractHomeSetup?.conferenceBannerImage) || "https://via.placeholder.com/800x600"})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: isSmallScreen ? 'center' : 'left',
                        padding: isSmallScreen ? '10px' : '20px',
                        color: 'white',
                    }}


                >

                    {/* <Typography variant={isSmallScreen ? 'h6' : 'h2'} component="div">
                        Conference Management System
                    </Typography> */}
                </Box>

                <Grid container justifyContent="center" marginTop="30px" style={{ width: '100%', marginLeft: isSmallScreen ? '0' : '-30px' }}>
                    <Grid item xs={12} sm={10} md={8} lg={6} style={{ width: '100%' }}>

                        {/* <Grid item xs={12} >
                            <Stepper activeStep={activeStep} alternativeLabel>
                                {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Grid> */}

                        <Grid item xs={12}>
                            <div>
                                {activeStep === steps.length ? (


                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        width: '100%',
                                        padding: '16px' // Add some padding on all sides
                                    }}>
                                        <Box sx={{
                                            width: '100%',
                                            maxWidth: { xs: '100%', md: '900px', lg: '1200px' }, // Responsive max width
                                            color: '#000000',
                                            marginTop: '5%'
                                        }}>
                                            {error_list && Object.keys(error_list)?.length > 0 && (
                                                <div>
                                                    {Object.keys(error_list)?.map((fieldName) => (
                                                        <div key={fieldName}>
                                                            {error_list[fieldName].map((error, index) => (
                                                                <span key={index} style={{ color: 'red' }}>{error}</span>
                                                            ))}
                                                        </div>
                                                    ))}

                                                    {/* Display button only if errors exist */}
                                                    {/* <Button
                                                        sx={{
                                                            float: 'left',
                                                            marginTop: '2%',
                                                            ":hover": {
                                                                color: "white"
                                                            },
                                                            backgroundColor: abstractHomeSetup.color_code_two
                                                                ? abstractHomeSetup.color_code_two
                                                                : gradientBackground,
                                                        }}
                                                        size="small"
                                                        variant="contained"
                                                        onClick={handleExtraButtonClick}
                                                    >
                                                        Back to Step 1
                                                    </Button>     */}


                                                </div>
                                            )}




                                            <Card sx={{
                                                ...cardStyles,
                                                width: '100%'
                                            }}>

                                                <CardContent >
                                                    <Typography component="h1" variant="h5" sx={{
                                                        textAlign: 'center', // Center the text
                                                    }}>
                                                        Check Out

                                                    </Typography>

                                                    <Box component="form" noValidate sx={{ mt: 3 }}>


                                                        {renderSelectedConferenceInfo()}




                                                    </Box>
                                                    <Grid container justifyContent="space-between">
                                                        <Button
                                                            onClick={handleBack}
                                                            variant="contained"
                                                            color="primary"
                                                            sx={{
                                                                mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                    ? abstractHomeSetup.color_code_two
                                                                    : gradientBackground,
                                                            }}
                                                            disabled={loading}>
                                                            {loading ? 'Loading...' : 'Back'}
                                                        </Button>


                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Box>
                                    </div>

                                ) : (
                                    <div>
                                        {/* <Typography>{steps[activeStep]}</Typography> */}
                                        {/* Render your form for each step */}
                                        {activeStep === 0 && (
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                width: '100%',
                                                margin: '0 auto',
                                                padding: '0 16px' /* optional padding */
                                                ,

                                            }}>


                                                <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                                                    <Grid container spacing={2} alignItems="center">
                                                        {/* Title - takes full width on small screens, 6 columns on large screens */}
                                                        <Grid item xs={12} lg={6}>
                                                            <Typography
                                                                component="h1"
                                                                variant="h5"
                                                                sx={{
                                                                    textAlign: { xs: 'center', lg: 'left' }, // Center on mobile, left on desktop
                                                                    marginTop: '2%',
                                                                }}
                                                            >
                                                                Conference Participant Details
                                                            </Typography>
                                                        </Grid>

                                                        {/* Buttons - takes full width on small screens, 6 columns on large screens */}
                                                        <Grid item xs={12} lg={6}>
                                                            <Box sx={{
                                                                display: 'flex',
                                                                justifyContent: { xs: 'center', lg: 'flex-end' }, // Center on mobile, right on desktop
                                                                gap: '10px', // Space between buttons
                                                                mt: { xs: '2%', lg: '0' } // Margin top only on mobile
                                                            }}>
                                                                <Button
                                                                    sx={{
                                                                        ":hover": { color: "white" },
                                                                        backgroundColor: abstractHomeSetup.color_code_two
                                                                            ? abstractHomeSetup.color_code_two
                                                                            : gradientBackground,
                                                                    }}
                                                                    color='success'
                                                                    size='small'
                                                                    variant='contained'
                                                                    component={Link}
                                                                    to="/conference/particpant-verification"
                                                                >
                                                                    Back To Verification
                                                                </Button>
                                                                {
                                                                    abstractHomeSetup.c_group_registration === 1 && (
                                                                        <Button
                                                                            sx={{
                                                                                ":hover": { color: "white" },
                                                                                backgroundColor: abstractHomeSetup.color_code_two
                                                                                    ? abstractHomeSetup.color_code_two
                                                                                    : gradientBackground,
                                                                            }}
                                                                            color='success'
                                                                            size='small'
                                                                            variant='contained'
                                                                            component={Link}
                                                                            to="/conference/participants-group-registration"
                                                                        >
                                                                            Group Registration
                                                                        </Button>
                                                                    )
                                                                }

                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                    <Card sx={{
                                                        ...cardStyles, // Preserves existing styles
                                                        width: {
                                                            xs: '100%',    // 100% on extra small screens
                                                            sm: '100%',    // 100% on small screens
                                                            md: '120%',    // 120% on medium screens
                                                            lg: '120%'     // 120% on large screens
                                                        },
                                                        maxWidth: '100vw', // Prevents horizontal scrolling
                                                        marginLeft: { md: '-10%', lg: '-10%' }, // Compensates for 120% width
                                                        //backgroundColor: 'red',
                                                        overflow: 'visible' // Allows content to extend beyond card bounds
                                                    }}>
                                                        <CardContent>
                                                            <Box component="form" noValidate sx={{ mt: 3 }}>
                                                                <Grid container spacing={4}>
                                                                    <Grid item xs={12} lg={6} sm={12}>
                                                                        <FormControl fullWidth>
                                                                            <InputLabel id="title-label">Title</InputLabel>
                                                                            <Select
                                                                                value={nameTitle}
                                                                                onChange={handleNameTitle}
                                                                                labelId="title-label"
                                                                                id="title-select"
                                                                                label="Title"
                                                                            >
                                                                                {['Mr', 'Mrs', 'Ms', 'Dr', 'Prof', 'Eng', 'Sheikh'].map(title => (
                                                                                    <MenuItem key={title} value={title}>{title}</MenuItem>
                                                                                ))}
                                                                            </Select>
                                                                            <FormHelperText>{addConferenceParticpant.error_list.name_title}</FormHelperText>
                                                                        </FormControl>
                                                                    </Grid>

                                                                    <Grid item xs={12} lg={6} sm={12}>
                                                                        <TextField
                                                                            required
                                                                            fullWidth
                                                                            label="Full Name"
                                                                            name='conference_partecpant_name'
                                                                            onChange={handleInput}
                                                                            value={addConferenceParticpant.conference_partecpant_name || ""}
                                                                            helperText={addConferenceParticpant.error_list.participant_name}
                                                                        />
                                                                    </Grid>
                                                                    {/* {AsActiveSaudiCouncilNo && (
                                                                        <Grid item xs={12} lg={6} sm={12}>
                                                                            <TextField
                                                                                required
                                                                                fullWidth
                                                                                label="Saudi Council No"
                                                                                type="text"
                                                                                name="saudiCouncilno"
                                                                                onChange={handleInput}
                                                                                value={addConferenceParticpant.saudiCouncilno || ""}
                                                                                helperText={addConferenceParticpant.error_list.participant_saudi_council_no}
                                                                            />
                                                                            <span style={{ color: 'red', display: 'block', marginTop: '4px' }}>
                                                                                If you don't have, type 0000
                                                                            </span>
                                                                        </Grid>
                                                                    )} */}
                                                                    {AsActiveSaudiCouncilNo === 1 && (
                                                                        <Grid item xs={12} lg={6} sm={12}>
                                                                            <TextField
                                                                                required
                                                                                fullWidth
                                                                                label="Council No"
                                                                                type="text"
                                                                                name="saudiCouncilno"
                                                                                onChange={handleInput}
                                                                                value={addConferenceParticpant.saudiCouncilno || ""}
                                                                                helperText={addConferenceParticpant.error_list.participant_saudi_council_no}
                                                                            />
                                                                            <span style={{ color: 'red', display: 'block', marginTop: '4px' }}>
                                                                                If you don't have, type 0000
                                                                            </span>
                                                                        </Grid>
                                                                    )}


                                                                    <Grid item xs={12} lg={6} sm={12}>
                                                                        <FormControl fullWidth>
                                                                            <InputLabel id="category-label">Conference Category</InputLabel>
                                                                            <Select
                                                                                value={registrationType || ""}
                                                                                //onChange={handleregistration}
                                                                                onChange={(e) => {
                                                                                    // Call the handleregistration function
                                                                                    handleregistration(e);

                                                                                    // Call the triggerRefresh function
                                                                                    //triggerRefresh();
                                                                                }}
                                                                                labelId="category-label"
                                                                                id="category-select"
                                                                                label="Conference Category"
                                                                            >
                                                                                {conferenceCategoryData && conferenceCategoryData.map(val => (
                                                                                    <MenuItem key={val.id} value={val.id}>{val.conference_category_title}</MenuItem>
                                                                                ))}
                                                                            </Select>
                                                                            <FormHelperText>{addConferenceParticpant.error_list.participant_conference_categoy}</FormHelperText>
                                                                        </FormControl>
                                                                    </Grid>

                                                                    <Grid item xs={12} lg={6} sm={12}>
                                                                        <TextField
                                                                            required
                                                                            fullWidth
                                                                            label="Email Address"
                                                                            name="participant_email"
                                                                            onChange={handleInput}
                                                                            value={addConferenceParticpant.participant_email || conference_particpant_email || ""}
                                                                            helperText={addConferenceParticpant.error_list.participant_email}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} lg={6} sm={12}>
                                                                        <TextField
                                                                            required
                                                                            fullWidth
                                                                            label="Password"
                                                                            type="password"
                                                                            name="password"
                                                                            value={addConferenceParticpant.password}
                                                                            onChange={handleInput}
                                                                            inputProps={{ minLength: 8 }} // browser validation
                                                                            helperText={addConferenceParticpant.error_list?.participant_password} // match error key
                                                                            // helperText={addConferenceParticpant.error_list?.password}
                                                                            error={Boolean(addConferenceParticpant.error_list?.participant_password)} />
                                                                    </Grid>

                                                                    <Grid item xs={12} lg={6} sm={12}>
                                                                        <TextField
                                                                            required
                                                                            fullWidth
                                                                            label="Mobile"
                                                                            type="text"
                                                                            name='phone'
                                                                            onChange={handleInput}
                                                                            value={addConferenceParticpant.phone || ""}
                                                                            helperText={addConferenceParticpant.error_list.participant_contact}
                                                                        />
                                                                    </Grid>

                                                                    <Grid item xs={12} lg={6} sm={12}>
                                                                        <TextField
                                                                            required
                                                                            fullWidth
                                                                            label="Profession"
                                                                            name='profession'
                                                                            onChange={handleInput}
                                                                            value={addConferenceParticpant.profession || ""}
                                                                            helperText={addConferenceParticpant.error_list.participant_profession}
                                                                        />
                                                                    </Grid>
                                                                    {/* <Grid item xs={12} lg={6} sm={12}>
                                                                        <TextField
                                                                            required
                                                                            fullWidth
                                                                            label="Level"
                                                                            name='level_of_education'
                                                                            onChange={handleInput}
                                                                            value={addConferenceParticpant.level_of_education || ""}
                                                                            helperText={addConferenceParticpant.error_list.level_of_education}
                                                                        />
                                                                    </Grid> */}
                                                                    <Grid item xs={12} lg={6} sm={12}>
                                                                        <TextField
                                                                            required
                                                                            fullWidth
                                                                            label="Hospital/Organization"
                                                                            name='hostpital_organization'
                                                                            onChange={handleInput}
                                                                            value={addConferenceParticpant.hostpital_organization || ""}
                                                                        />
                                                                    </Grid>


                                                                    <Grid item xs={12} lg={6} sm={12}>
                                                                        <FormControl fullWidth>
                                                                            <InputLabel id="country-label">Country</InputLabel>
                                                                            <Select
                                                                                value={country}
                                                                                onChange={handleCountry}
                                                                                labelId="country-label"
                                                                                id="country-select"
                                                                                label="Country"

                                                                            >
                                                                                {countries.map((country) => (
                                                                                    <MenuItem key={country} value={country}>{country}</MenuItem>
                                                                                ))}
                                                                            </Select>
                                                                            <FormHelperText></FormHelperText>
                                                                        </FormControl>
                                                                    </Grid>


                                                                    <Grid item xs={12} lg={6} sm={12}>
                                                                        <TextField
                                                                            required
                                                                            fullWidth
                                                                            label="City"
                                                                            name='city'
                                                                            onChange={handleInput}
                                                                            value={addConferenceParticpant.city || ""}
                                                                        />
                                                                    </Grid>

                                                                    <Grid item xs={12} lg={6} sm={12}>
                                                                        <FormControl>
                                                                            <FormLabel>Gender</FormLabel>
                                                                            <RadioGroup
                                                                                row
                                                                                name="gender"
                                                                                value={gender}
                                                                                onChange={handleChange}
                                                                            >
                                                                                <FormControlLabel value="0" control={<Radio />} label="Male" />
                                                                                <FormControlLabel value="1" control={<Radio />} label="Female" />
                                                                            </RadioGroup>
                                                                            <FormHelperText>{addConferenceParticpant.error_list.participant_gender}</FormHelperText>
                                                                        </FormControl>
                                                                    </Grid>
                                                                </Grid>
                                                                {singleConferenceCategory && (
                                                                    <>
                                                                        <br></br>

                                                                        <Card item xs={12} sm={12} md={12} lg={12} style={{ width: '100%', }} >
                                                                            <CardContent >
                                                                                <Typography component="h1" variant="h5" sx={{
                                                                                    textAlign: 'center', // Center the text
                                                                                }}>
                                                                                    Registration Fees
                                                                                </Typography>
                                                                                <br></br>
                                                                                <Typography
                                                                                    component="h6"
                                                                                    variant="h5"
                                                                                    sx={{
                                                                                        textAlign: 'center', // Center the text
                                                                                        color: 'red', // Set the text color to red
                                                                                    }} >
                                                                                    {addConferenceParticpant.error_list.selectedConferenceAmounts}
                                                                                </Typography>


                                                                                <Box component="form" noValidate sx={{ mt: 3 }}>

                                                                                    <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: '100%' }}>
                                                                                        <TableCell colSpan={5} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                                                            <FormControlLabel
                                                                                                control={<Checkbox color="success" checked={singleConferenceCategory.conference_category_title !== null} />}
                                                                                                label={
                                                                                                    <span
                                                                                                        sx={{
                                                                                                            margin: '55px',
                                                                                                            display: 'inline-block',
                                                                                                        }}
                                                                                                    >
                                                                                                        {singleConferenceCategory.conference_category_title}
                                                                                                    </span>
                                                                                                }
                                                                                                color="success"
                                                                                                name="permissions"
                                                                                            />
                                                                                        </TableCell>



                                                                                        <TableContainer component={Paper}>
                                                                                            {/* Add currency selector above the table */}
                                                                                            <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                                                                                <FormControl sx={{ minWidth: 120 }}>
                                                                                                    <InputLabel>Currency</InputLabel>
                                                                                                    <Select
                                                                                                        value={selectedCurrency}
                                                                                                        label="Currency"
                                                                                                        //onChange={(e) => setSelectedCurrency(e.target.value)}
                                                                                                        onChange={handleCurrencyChange}
                                                                                                        disabled={event_affiliate_status ? true : false} // Disable if event_affiliate_status is true
                                                                                                    >
                                                                                                        {currencyOptions.map((option) => (
                                                                                                            <MenuItem key={option.value} value={option.value}>
                                                                                                                {option.label}
                                                                                                            </MenuItem>
                                                                                                        ))}
                                                                                                    </Select>
                                                                                                </FormControl>
                                                                                            </Box>

                                                                                            <Table>
                                                                                                <TableHead>
                                                                                                    <TableRow>
                                                                                                        {isMobile ? (
                                                                                                            <TableCell colSpan={5} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                                                                                Conference Informations
                                                                                                            </TableCell>
                                                                                                        ) : (
                                                                                                            <>
                                                                                                                <TableCell>ID</TableCell>
                                                                                                                <TableCell>Conference Name</TableCell>
                                                                                                                <TableCell>Conference Day</TableCell>
                                                                                                                <TableCell>Conference Date</TableCell>
                                                                                                                <TableCell>Conference End Date</TableCell>
                                                                                                                <TableCell>Conference Start Time</TableCell>
                                                                                                                <TableCell>Conference End Time</TableCell>
                                                                                                                <TableCell>Price ({selectedCurrency})</TableCell>
                                                                                                                <TableCell>Select</TableCell>
                                                                                                            </>
                                                                                                        )}
                                                                                                    </TableRow>
                                                                                                </TableHead>
                                                                                                <TableBody>
                                                                                                    {singleConferenceCategory.conferences &&
                                                                                                        singleConferenceCategory.conferences.map((row, i) => (
                                                                                                            <TableRow key={row.id} style={{
                                                                                                                backgroundColor: isCheckboxDisabled(row).color,
                                                                                                            }}>
                                                                                                                {isMobile ? (
                                                                                                                    <>
                                                                                                                        <TableCell style={{ display: 'flex', flexWrap: 'wrap', flexBasis: '100%', paddingLeft: '20px' }}>
                                                                                                                            {/* ... other mobile cells ... */}

                                                                                                                            <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                <strong>No: {i + 1} </strong>

                                                                                                                            </Box>
                                                                                                                            <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                <strong>Conference Name:</strong> {row.conference_name}

                                                                                                                            </Box>

                                                                                                                            <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                <strong>Conference Day:</strong> {row.conference_day}

                                                                                                                            </Box>
                                                                                                                            <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                <strong>Conference Date:</strong> {row.conference_date}

                                                                                                                            </Box>
                                                                                                                            <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                <strong>Conference End Date:</strong> {row.conference_end_date}

                                                                                                                            </Box>

                                                                                                                            <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                <strong>Conference Start Time:</strong> {row.conference_start_time}

                                                                                                                            </Box>
                                                                                                                            <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                <strong>Conference End Time:</strong> {row.conference_end_time}

                                                                                                                            </Box>
                                                                                                                            <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                <strong>Price ({selectedCurrency}):</strong>
                                                                                                                                {event_affiliate_status ? (
                                                                                                                                    <>
                                                                                                                                        <span style={{ textDecoration: 'line-through', marginRight: '8px', color: 'gray' }}>
                                                                                                                                            {getPriceByCurrency(row, selectedCurrency)}
                                                                                                                                        </span>
                                                                                                                                        <span style={{ color: 'green', fontWeight: 'bold' }}>
                                                                                                                                            {row.conference_discount_amount}
                                                                                                                                        </span>
                                                                                                                                    </>
                                                                                                                                ) : (
                                                                                                                                    getPriceByCurrency(row, selectedCurrency)
                                                                                                                                )}
                                                                                                                            </Box>

                                                                                                                            {/* ... rest of mobile cells ... */}
                                                                                                                            <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                <div style={{ fontWeight: 'bold', fontSize: '20px' /* base + 4px */ }}>
                                                                                                                                    Select Conference:
                                                                                                                                </div>

                                                                                                                                {/* <Checkbox
                                                                                                                                    checked={selectedConferences.some((selectedConference) => selectedConference.id === row.id)}
                                                                                                                                    // onChange={(e) => handleCheckboxChange(e, row, row.conference_amount)}
                                                                                                                                    onChange={(e) => handleCheckboxChange(e, row, event_affiliate_status ? row.conference_discount_amount : row.conference_amount)}
                                                                                                                                    disabled={isCheckboxDisabled(row).isDisabled}
                                                                                                                                    sx={{
                                                                                                                                        mt: 1,
                                                                                                                                        color: abstractHomeSetup.color_code_two
                                                                                                                                            ? abstractHomeSetup.color_code_two
                                                                                                                                            : gradientBackground,
                                                                                                                                        fontWeight: 'bold',
                                                                                                                                        transform: 'scale(2)', // Makes the checkbox larger
                                                                                                                                        '&.Mui-checked': {
                                                                                                                                            color: abstractHomeSetup.color_code_two
                                                                                                                                                ? abstractHomeSetup.color_code_two
                                                                                                                                                : gradientBackground,
                                                                                                                                        },
                                                                                                                                    }} /> */}
                                                                                                                                <Checkbox
                                                                                                                                    checked={selectedConferences.some((selectedConference) => selectedConference.id === row.id)}
                                                                                                                                    onChange={(e) => handleCheckboxChange(e, row, event_affiliate_status ? row.conference_discount_amount : getPriceByCurrency(row, selectedCurrency))}
                                                                                                                                    disabled={isCheckboxDisabled(row).isDisabled}
                                                                                                                                    sx={{
                                                                                                                                        color: abstractHomeSetup.color_code_two
                                                                                                                                            ? abstractHomeSetup.color_code_two
                                                                                                                                            : gradientBackground,
                                                                                                                                        fontWeight: 'bold',
                                                                                                                                        transform: 'scale(1)',
                                                                                                                                        '&.Mui-checked': {
                                                                                                                                            color: abstractHomeSetup.color_code_two
                                                                                                                                                ? abstractHomeSetup.color_code_two
                                                                                                                                                : gradientBackground,
                                                                                                                                        },
                                                                                                                                    }}
                                                                                                                                />

                                                                                                                                {isCheckboxDisabled(row).seatLimitMessage && (
                                                                                                                                    <span style={{ color: 'red' }}>
                                                                                                                                        {isCheckboxDisabled(row).seatLimitMessage}
                                                                                                                                    </span>
                                                                                                                                )}




                                                                                                                                {isCheckboxDisabled(row).timeOffMessage && (
                                                                                                                                    <span style={{ color: 'orange' }}>
                                                                                                                                        {isCheckboxDisabled(row).timeOffMessage}
                                                                                                                                    </span>
                                                                                                                                )}
                                                                                                                                <hr></hr>

                                                                                                                            </Box>

                                                                                                                        </TableCell>
                                                                                                                    </>
                                                                                                                ) : (
                                                                                                                    <>
                                                                                                                        <TableCell>{i + 1}</TableCell>
                                                                                                                        <TableCell>{row.conference_name}</TableCell>
                                                                                                                        <TableCell>{row.conference_day}</TableCell>
                                                                                                                        <TableCell>{row.conference_date}</TableCell>
                                                                                                                        <TableCell>{row.conference_end_date}</TableCell>
                                                                                                                        <TableCell>{row.conference_start_time}</TableCell>
                                                                                                                        <TableCell>{row.conference_end_time}</TableCell>
                                                                                                                        <TableCell>
                                                                                                                            {event_affiliate_status ? (
                                                                                                                                <>
                                                                                                                                    <span style={{ textDecoration: 'line-through', marginRight: '5px' }}>
                                                                                                                                        {getPriceByCurrency(row, selectedCurrency)}
                                                                                                                                    </span>
                                                                                                                                    <span style={{ color: 'red', fontWeight: 'bold' }}>
                                                                                                                                        {row.conference_discount_amount}
                                                                                                                                    </span>
                                                                                                                                </>
                                                                                                                            ) : (
                                                                                                                                getPriceByCurrency(row, selectedCurrency)
                                                                                                                            )}
                                                                                                                        </TableCell>
                                                                                                                        <TableCell>
                                                                                                                            <Checkbox
                                                                                                                                checked={selectedConferences.some((selectedConference) => selectedConference.id === row.id)}
                                                                                                                                onChange={(e) => handleCheckboxChange(e, row, event_affiliate_status ? row.conference_discount_amount : getPriceByCurrency(row, selectedCurrency))}
                                                                                                                                disabled={isCheckboxDisabled(row).isDisabled}
                                                                                                                                sx={{
                                                                                                                                    color: abstractHomeSetup.color_code_two
                                                                                                                                        ? abstractHomeSetup.color_code_two
                                                                                                                                        : gradientBackground,
                                                                                                                                    fontWeight: 'bold',
                                                                                                                                    transform: 'scale(1)',
                                                                                                                                    '&.Mui-checked': {
                                                                                                                                        color: abstractHomeSetup.color_code_two
                                                                                                                                            ? abstractHomeSetup.color_code_two
                                                                                                                                            : gradientBackground,
                                                                                                                                    },
                                                                                                                                }}
                                                                                                                            />
                                                                                                                            {isCheckboxDisabled(row).seatLimitMessage && (
                                                                                                                                <span style={{ color: 'red' }}>{isCheckboxDisabled(row).seatLimitMessage}</span>
                                                                                                                            )}
                                                                                                                            {isCheckboxDisabled(row).timeOffMessage && (
                                                                                                                                <span style={{ color: 'orange' }}>{isCheckboxDisabled(row).timeOffMessage}</span>
                                                                                                                            )}
                                                                                                                        </TableCell>
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </TableRow>
                                                                                                        ))}
                                                                                                </TableBody>
                                                                                            </Table>
                                                                                        </TableContainer>
                                                                                    </Grid>

                                                                                    <Grid container justifyContent="space-between">
                                                                                        {/* <Button

                                                                                            disabled={activeStep === 0}
                                                                                            variant="contained"
                                                                                            color="primary"
                                                                                            onClick={handleBack}
                                                                                            sx={{
                                                                                                mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                                                    ? abstractHomeSetup.color_code_two
                                                                                                    : gradientBackground,
                                                                                            }}>
                                                                                            Back
                                                                                        </Button> */}


                                                                                        {/* <Button
                                                                                            variant="contained"
                                                                                            color="primary"
                                                                                            onClick={handleNext}

                                                                                            sx={{
                                                                                                mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                                                    ? abstractHomeSetup.color_code_two
                                                                                                    : gradientBackground
                                                                                            }}
                                                                                            disabled={isSaveButtonDisabled}
                                                                                        >
                                                                                            {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                                                                                        </Button> */}
                                                                                    </Grid>

                                                                                </Box>
                                                                            </CardContent>
                                                                        </Card>
                                                                    </>

                                                                )}


                                                                <Grid container justifyContent="space-between">
                                                                    <Button disabled={activeStep === 0} onClick={handleBack} sx={{ mt: 5 }}>
                                                                        Back
                                                                    </Button>
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        onClick={handleNextClick}
                                                                        disabled={!isFormValid() || isSaveButtonDisabled}
                                                                        sx={{
                                                                            mt: 5,
                                                                            backgroundColor: abstractHomeSetup.color_code_two || gradientBackground,
                                                                        }}
                                                                    >
                                                                        {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                                                                    </Button>
                                                                </Grid>
                                                            </Box>
                                                        </CardContent>
                                                    </Card>




                                                </Box>

                                            </div>

                                        )}



                                    </div>
                                )}
                            </div>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

            <Grid item xs={12} sm={10} md={8} lg={6} marginTop="40px">
                <NewVersionAbstractFooter />
            </Grid>
        </div >

    );
};
export default ConferencePartiticpantForm;
